import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  manufacturerApi,
  type CreateProducerRequest,
  type UpdateProfileRequest,
} from '@entities/manufacturer';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useCreateProducer() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: CreateProducerRequest) => manufacturerApi.create(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['manufacturers'] });
    },
    onError: (e: Error) => toast.error('Не удалось создать', e.message),
  });
}

export function useUpdateProfile(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: UpdateProfileRequest) => manufacturerApi.updateProfile(id, body),
    onSuccess: () => {
      toast.success('Профиль сохранён');
      void qc.invalidateQueries({ queryKey: ['manufacturer', id] });
      void qc.invalidateQueries({ queryKey: ['manufacturers'] });
    },
    onError: (e: Error) => toast.error('Не удалось сохранить', e.message),
  });
}

export function useSetPassword(id: UUID) {
  const toast = useToast();
  return useMutation({
    mutationFn: (password: string) => manufacturerApi.setPassword(id, { password }),
    onSuccess: () => toast.success('Пароль выдан', 'Активные сессии вендора завершены'),
    onError: (e: Error) => toast.error('Не удалось выдать пароль', e.message),
  });
}
